import React, { useState, useEffect } from "react";
import { Row, Col, Skeleton } from "antd";
import BreadcrumbComponent from "./Breadcrumb";
import PageTitle from "./PageTitle";
import Table from "./Table";
import { useParams } from "react-router-dom";
import "./table.css";
import { sendData, getData } from "store/firebase/methods";
import axios from "axios";
import algoliasearch from "algoliasearch/lite";
import API_KEY from "../../../../api/index";

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_CLIENT,
  process.env.REACT_APP_ALGOLIA_KEY
);

const index = searchClient.initIndex("products");
// const filterSearch = `secondary_category.name:${selectedCategory}`;

export default function TableV2() {
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showCost, setShowCost] = useState(false);
  const [defaults, setDefaults] = useState(null);
  const [loadingProductCost, setLoadingProductCost] = useState(false);
  const [productCount, setProductCount] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const org = localStorage.getItem("org");
    const orgDetails = org && JSON.parse(org);

    index
      .search(" ", {
        facets: ["transformedAttributes.*", "sub_category"],
        filters: `manufacturer:${orgDetails?.id || ""}`,
      })
      .then((res) => {
        const results = res.facets;
        let facetInfo = [];

        for (let key in results) {
          const facetName = key.split(".").length > 1 ? key.split(".")[1] : key;

          facetInfo.push({ [facetName]: Object.keys(results[key]) });
        }
        setDefaults(Object.assign({}, ...facetInfo));
      });
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const user = userData && JSON.parse(userData);
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_SERVICE}items/table/collection_products`,
        {
          params: {
            collection_id: id,
            access_token: user?.access_token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        setTableData(res?.data);
        const { collection_info = {} } = res?.data;
        sessionStorage.setItem(
          "collectionDetails",
          JSON.stringify(collection_info)
        );
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    API_KEY.URL.get(`${API_KEY.path.table}/${id}`)
      .then((res) => {
        const data = res.data?.data?.[0];
        mapData(data);
      })
      .catch((err) => {});
  }, [id]);

  const mapData = (data) => {
    let selecteProducts = [];

    data?.products?.forEach((product) => {
      let categoryName = product?.products_id?.secondary_categoryname;
      let categoryId = product?.products_id?.secondary_categoryid;
      let id = product?.products_id?.id;

      let productObj = {
        collection_product_id: product?.id,
        product_id: product?.products_id?.product_id,
        product_images: product?.products_id?.product_images,
        attributes: product?.attributes,
        prodId: id,
        visible_attributes: product?.visible_attributes,
        hasVariant: product?.hasVariant,
        numVariants: product?.numVariants,
        is_exclusive_product: product?.is_exclusive_product,
        exclusive_buyer_details: product?.exclusive_buyer_details,
      };
      selecteProducts.push({
        primary_key: { name: categoryName, id: categoryId },
        secondary_key: { productObj },
      });
    });

    if (selecteProducts.length > 0) {
      const products = selecteProducts.map((item) => {
        delete item?.secondary_key?.productObj?.id;
        return {
          secondary_category: { ...item.primary_key },
          ...item.secondary_key?.productObj,
          id: item.secondary_key?.productObj?.prodId,
        };
      });

      // localStorage.setItem("selectedProducts", JSON.stringify(products));
      sendData(products);
    } else {
      // localStorage.setItem("selectedProducts", JSON.stringify([]));
      sendData([]);
    }
  };
  return (
    <>
      <Row>
        <Col span={24}>
          <BreadcrumbComponent collectionId={id} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <PageTitle
            showCost={showCost}
            setShowCost={setShowCost}
            collectionId={id}
            tableData={tableData}
            saving={saving}
            setSaving={setSaving}
            setTableData={setTableData}
            loadingProductCost={loadingProductCost}
            setLoadingProductCost={setLoadingProductCost}
            productCount={productCount}
            setProductCount={setProductCount}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            showCost={showCost}
            data={tableData}
            saving={saving}
            setSaving={setSaving}
            defaults={defaults}
            loadingProductCost={loadingProductCost}
            setLoadingProductCost={setLoadingProductCost}
            productCount={productCount}
            setProductCount={setProductCount}
          />
        </Col>
      </Row>
    </>
  );
}
